import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/J3_Teleruptor_run_forcing.svg"

const J3Teleruptorrunforcing: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 76 76'} component={Icon} {...props} fill="currentColor" />
export default J3Teleruptorrunforcing
